export default "__VITE_ASSET__CISXpBH6__"